import { HttpErrorResponse } from '@angular/common/http';

import { t } from './translate';

/**
 * Resolves an HTTP error to a message for in-form display, or `null` when the
 * error must not be shown in the form. Every 5xx returns `null`: those are owned
 * by the global server-error modal (apiErrorInterceptor + ServerErrorRetryService),
 * so a form must not double-report them. Every other failure (4xx, network)
 * yields a message — the server text when present, otherwise a generic fallback.
 */
export function formServerError(error: unknown): string | null {
  if (!(error instanceof HttpErrorResponse) || error.status >= 500) {
    return null;
  }
  return extractMessage(error.error) ?? t('wpp.form-server-error.generic');
}

export function extractMessage(body: unknown): string | null {
  if (typeof body !== 'object' || body === null) {
    return null;
  }
  const inner: unknown = (body as { error?: unknown }).error;
  if (typeof inner === 'string' && inner.trim() !== '') {
    return inner;
  }
  if (typeof inner === 'object' && inner !== null) {
    const message: unknown = (inner as { message?: unknown }).message;
    if (typeof message === 'string' && message.trim() !== '') {
      return message;
    }
  }
  const topMessage: unknown = (body as { message?: unknown }).message;
  return typeof topMessage === 'string' && topMessage.trim() !== '' ? topMessage : null;
}
